import React, { useContext } from 'react';
import { Colors } from '@common/tokens';
import { getLetterSignByNumber } from '@approvals/services/approvals-service';
import {
  generateEmptyApprovalChain,
  getKey,
  removeItem,
} from '@approvals/services/approvals-page-drawer-service';
import { Button } from 'antd';
import { ApprovalsEditDrawerDeleteButton } from './_approvals-edit-drawer-delete-button';
import { ApprovalsEditDrawerListStep } from './_approvals-edit-drawer-list-steps';
import { ApprovalDrawerContext } from './approvals-edit-drawer';
import { ApprovalChainTemplateType } from '@approvals/graphql';

type Props = {
  approvalChainTemplates: ApprovalChainTemplateType[];
};

export const ApprovalsEditDrawerListApprovalChains = ({
  approvalChainTemplates,
}: Props) => {
  const { preApproved, forceUpdate } = useContext(ApprovalDrawerContext);

  function addChain() {
    approvalChainTemplates.push(generateEmptyApprovalChain());
    forceUpdate();
  }

  function removeChain(index: number) {
    removeItem(approvalChainTemplates, index);
    forceUpdate();
  }

  if (approvalChainTemplates.length === 0) {
    addChain();
  }

  const remainingApprovalChainTemplates = approvalChainTemplates.filter(
    (item) => !item.destroy
  );

  return (
    <>
      <ul className="approvals-drawer__lists">
        {approvalChainTemplates.map((approvalChain, approvalChainIndex) => {
          const letterSign = getLetterSignByNumber(approvalChainIndex);
          return (
            !approvalChain.destroy && (
              <li
                key={getKey(approvalChain)}
                className="approvals-drawer__approval-chain-item"
              >
                {remainingApprovalChainTemplates.length > 1 && (
                  <ApprovalsEditDrawerDeleteButton
                    onClick={() => removeChain(approvalChainIndex)}
                    disabled={preApproved}
                    tooltip={`Remove Approval Chain ${letterSign}`}
                    topOffset={5}
                  />
                )}
                <h4 className="approvals-drawer__approval-chain-title">
                  APPROVAL CHAIN {letterSign}
                  {letterSign === 'A' && ' (DEFAULT)'}
                </h4>
                <ApprovalsEditDrawerListStep
                  steps={approvalChain.approvalChainStepTemplates}
                />
              </li>
            )
          );
        })}
      </ul>
      <Button disabled={preApproved} onClick={addChain}>
        Add Approval Chain
      </Button>
      <style jsx>{`
        .approvals-drawer__approval-chain-item {
          position: relative;
          background: ${Colors.elmHyperlight};
          padding: 16px;
          border: 1px solid ${Colors.steel};
          border-radius: 4px;
          font-size: 16px;
          margin-bottom: 24px;
        }
        .approvals-drawer__approval-chain-title {
          font-weight: 500;
          letter-spacing: 0.5px;
        }
        .approvals-drawer__lists {
          list-style: none;
          padding: 0;
          margin-bottom: 8px;
        }
      `}</style>
    </>
  );
};
